/* Puro Equilibrio — comportamiento de los componentes "bb" */
(function () {
  if (window.__bbLoaded) return;
  window.__bbLoaded = true;

  /* Carrusel horizontal con flechas (productos y opiniones) */
  if (!customElements.get('bb-scroller')) {
    customElements.define(
      'bb-scroller',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-bb-track]');
          if (!this.track) return;
          this.prev = this.querySelector('[data-bb-prev]');
          this.next = this.querySelector('[data-bb-next]');
          this.onScroll = () => this.update();
          this.track.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll);
          if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
          if (this.next) this.next.addEventListener('click', () => this.go(1));
          this.update();
        }
        disconnectedCallback() {
          window.removeEventListener('resize', this.onScroll);
        }
        go(dir) {
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.8, behavior: 'smooth' });
        }
        update() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          if (this.prev) this.prev.disabled = t.scrollLeft <= 4;
          if (this.next) this.next.disabled = t.scrollLeft >= max - 4;
        }
      }
    );
  }

  /* Barra de anuncios rotativa */
  if (!customElements.get('bb-announce')) {
    customElements.define(
      'bb-announce',
      class extends HTMLElement {
        connectedCallback() {
          this.msgs = Array.from(this.querySelectorAll('.bb-announce__msg'));
          if (this.msgs.length < 2) return;
          if (window.Shopify && window.Shopify.designMode) return;
          this.i = 0;
          this.ms = Math.max(3000, parseInt(this.dataset.interval, 10) || 5000);
          this.start();
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
        }
        disconnectedCallback() {
          this.stop();
        }
        start() {
          if (this.timer || !this.ms) return;
          this.timer = window.setInterval(() => this.show(this.i + 1), this.ms);
        }
        stop() {
          if (this.timer) window.clearInterval(this.timer);
          this.timer = null;
        }
        show(n) {
          this.i = (n + this.msgs.length) % this.msgs.length;
          this.msgs.forEach((m, k) => m.classList.toggle('is-active', k === this.i));
        }
      }
    );
  }

  /* Barra de compra fija en móvil: elegir talla y comprar sin subir */
  if (!customElements.get('bb-sticky-buy')) {
    customElements.define(
      'bb-sticky-buy',
      class extends HTMLElement {
        connectedCallback() {
          this.bar = this.querySelector('.bb-sticky-buy');
          this.btn = this.querySelector('[data-bb-sticky-btn]');
          this.select = this.querySelector('[data-bb-sticky-size]');
          this.priceEl = this.querySelector('[data-bb-sticky-price]');
          this.sizeName = this.dataset.sizeName || '';
          this.target = document.querySelector('product-form .product-form__submit');
          if (!this.bar || !this.btn || !this.target) return;
          this.label = this.btn.textContent;

          this.btn.addEventListener('click', () => {
            if (!this.btn.disabled) this.target.click();
          });
          if (this.select) {
            this.select.addEventListener('change', () => this.pushSize());
          }
          this.onMainChange = (e) => {
            if (e.target && e.target.matches && e.target.matches('input[type=radio]')) {
              window.setTimeout(() => this.pull(), 350);
            }
          };
          document.addEventListener('change', this.onMainChange);

          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              (entries) => {
                this.bar.classList.toggle('is-on', !entries[0].isIntersecting);
              },
              { threshold: 0 }
            );
            this.io.observe(this.target);
          }
          this.pull();
        }
        disconnectedCallback() {
          if (this.io) this.io.disconnect();
          if (this.onMainChange) document.removeEventListener('change', this.onMainChange);
        }
        sizeInputs() {
          if (!this.sizeName) return [];
          return Array.from(document.querySelectorAll('input[type=radio][data-option-name]')).filter(
            (i) => i.dataset.optionName === this.sizeName
          );
        }
        pushSize() {
          const v = this.select.value;
          const input = this.sizeInputs().find((i) => i.value === v);
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        pull() {
          const checked = this.sizeInputs().find((i) => i.checked);
          if (this.select && checked && this.select.value !== checked.value) this.select.value = checked.value;
          if (this.select) {
            const byValue = {};
            this.sizeInputs().forEach((i) => { byValue[i.value] = i.classList.contains('disabled'); });
            Array.from(this.select.options).forEach((o) => { o.disabled = !!byValue[o.value]; });
          }
          const priceNode = document.querySelector('.product__info-container .price .price-item--last, .product__info-container .price-item--regular');
          if (this.priceEl && priceNode) this.priceEl.textContent = priceNode.textContent.trim();
          const blocked = this.target.disabled || this.target.getAttribute('aria-disabled') === 'true';
          this.btn.disabled = blocked;
          this.btn.textContent = blocked ? 'No disponible' : this.label;
        }
      }
    );
  }

  /* Cuenta atrás hacia una fecha real */
  if (!customElements.get('bb-oferta')) {
    customElements.define(
      'bb-oferta',
      class extends HTMLElement {
        connectedCallback() {
          this.out = this.querySelector('[data-bb-oferta-time]');
          this.daily = this.dataset.mode === 'diaria';
          const raw = (this.dataset.end || '').trim().replace(' ', 'T');
          this.end = this.daily ? NaN : (raw ? new Date(raw).getTime() : NaN);
          if (!this.out || (!this.daily && isNaN(this.end))) { this.hidden = true; return; }
          this.tick();
          this.timer = window.setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() {
          if (this.timer) window.clearInterval(this.timer);
        }
        tick() {
          if (this.daily) { const m = new Date(); m.setHours(24, 0, 0, 0); this.end = m.getTime(); }
          const ms = this.end - Date.now();
          if (ms <= 0) { this.hidden = true; if (this.timer) window.clearInterval(this.timer); return; }
          this.hidden = false;
          const s = Math.floor(ms / 1000);
          const d = Math.floor(s / 86400);
          const p = (n) => String(n).padStart(2, '0');
          const hms = p(Math.floor((s % 86400) / 3600)) + ':' + p(Math.floor((s % 3600) / 60)) + ':' + p(s % 60);
          this.out.textContent = d > 0 ? d + ' d ' + hms : hms;
        }
      }
    );
  }

  /* Sugerencias en la cesta: añadir sin salir de la cesta */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-bb-upsell-add]');
    if (!btn) return;
    const card = btn.closest('[data-bb-upsell]');
    const select = card && card.querySelector('select');
    const id = select ? select.value : btn.dataset.variantId;
    if (!id || btn.disabled) return;
    const drawer = btn.closest('cart-drawer');
    const errorBox = btn.closest('.bb-upsell') && btn.closest('.bb-upsell').querySelector('.bb-upsell__error');
    const label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Añadiendo…';
    if (errorBox) errorBox.hidden = true;
    try {
      const body = { id: Number(id), quantity: 1 };
      if (drawer) {
        body.sections = 'cart-drawer,cart-icon-bubble';
        body.sections_url = window.location.pathname;
      }
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message || 'No se pudo añadir');
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(data);
      else window.location.reload();
    } catch (err) {
      btn.disabled = false;
      btn.textContent = label;
      if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
    }
  });

  /* Pop-up de bienvenida discreto */
  if (!customElements.get('bb-popup')) {
    customElements.define(
      'bb-popup',
      class extends HTMLElement {
        read(k, area) {
          try { return (area || localStorage).getItem(k); } catch (e) { return null; }
        }
        write(k, v, area) {
          try { (area || localStorage).setItem(k, v); } catch (e) { /* sin almacenamiento */ }
        }
        connectedCallback() {
          this.card = this.querySelector('.bb-popup__card');
          if (!this.card) return;
          this.pageType = this.dataset.pageType || '';
          this.days = parseInt(this.dataset.days, 10) || 14;
          this.retries = 0;

          this.querySelectorAll('[data-bb-popup-close]').forEach((b) => b.addEventListener('click', () => this.close()));
          this.onKey = (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); };
          document.addEventListener('keydown', this.onKey);

          const form = this.querySelector('form');
          if (form) form.addEventListener('submit', () => this.write('bb_popup_sub', '1', sessionStorage));

          const copy = this.querySelector('[data-bb-popup-copy]');
          if (copy) {
            copy.addEventListener('click', () => {
              const code = (this.querySelector('[data-bb-popup-code]') || {}).textContent || '';
              const done = () => { copy.textContent = 'Copiado'; };
              if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code.trim()).then(done, done);
              else done();
            });
          }

          if (window.Shopify && window.Shopify.designMode) return;

          const ok = this.querySelector('[data-bb-popup-ok]');
          if (ok && this.read('bb_popup_sub', sessionStorage) === '1') {
            try { sessionStorage.removeItem('bb_popup_sub'); } catch (e) { /* nada */ }
            this.write('bb_popup_done', '1');
            this.open();
            return;
          }
          if (this.read('bb_popup_done')) return;
          if (Date.now() < Number(this.read('bb_popup_until') || 0)) return;
          if (this.read('bb_popup_seen', sessionStorage)) return;
          if (['cart', 'password', '404'].indexOf(this.pageType) > -1) return;
          if (
            this.dataset.hideMobileProduct === 'true' &&
            this.pageType === 'product' &&
            window.matchMedia('(max-width: 749px)').matches
          ) return;

          this.timer = window.setTimeout(() => this.tryOpen(), Math.max(3000, parseInt(this.dataset.delay, 10) || 8000));
        }
        disconnectedCallback() {
          if (this.timer) window.clearTimeout(this.timer);
          document.removeEventListener('keydown', this.onKey);
        }
        busy() {
          const consent = document.getElementById('shopify-pc__banner');
          const consentVisible = consent && consent.offsetParent !== null;
          const drawer = document.querySelector('cart-drawer.active, cart-drawer.animate');
          const menu = document.querySelector('.menu-opening, details[open] > .search-modal, details-modal[open]');
          return !!(consentVisible || drawer || menu);
        }
        tryOpen() {
          if (this.busy() && this.retries < 6) {
            this.retries += 1;
            this.timer = window.setTimeout(() => this.tryOpen(), 4000);
            return;
          }
          if (this.busy()) return;
          this.open();
          this.write('bb_popup_seen', '1', sessionStorage);
        }
        open() {
          this.hidden = false;
          window.setTimeout(() => this.classList.add('is-open'), 30);
        }
        close() {
          this.classList.remove('is-open');
          window.setTimeout(() => { this.hidden = true; }, 300);
          if (!this.read('bb_popup_done')) this.write('bb_popup_until', String(Date.now() + this.days * 86400000));
        }
      }
    );
  }
})();
